<template>
    <div class="card-item">
        <div class="title-wrapper">
            <a :href="course.url" class="clean">
                <h3 :style="{color: corporationColor}">{{course.name}}</h3>
            </a>
            <a href="javascript:" class="m-md-right pull-left">
                <i :class="{'new-bg-wish-disabled': !course.has_like, 'new-bg-wish-active': course.has_like}"
                   @click="changeReaction()">
                </i>
            </a>
        </div>
        <div class="image-wrapper-container">
           <div class="image-wrapper">
               <i class="bg-gris"></i>
               <i class="bg-onsite"></i>
               <i v-if="course.space === course.available" class="new-bg-new"></i>
               <p v-if="course.space === course.available">{{t('NEW')}}</p>
               <div v-if="course.space > course.available && course.available <= 3 && course.available !== 0" class="attention-wrapper">
                   <div class="text">
                       <i class="bg-attention"></i>
                       <span>{{course.available}} {{t('LEFT')}}</span>
                   </div>
               </div>
               <div v-if="course.available === 0" class="attention-wrapper">
                    <div class="text">
                       <i class="new-bg-ok"></i>
                       <span class="full">{{t('FULL')}}</span>
                    </div>
               </div>
               <div v-if="course.space > course.available && course.available > 3 && course.available !== 0" class="attention-wrapper">
                    <div class="text">
                       <i class="new-bg-ok-green"></i>
                       <span class="available">{{course.available}}/{{course.space}}</span>
                    </div>
               </div>
               <a :href="course.url" class="clean">
                  <img :src="course.image" class="img-responsive">
               </a>
           </div>
        </div>
        <div class="options">
           <ul class="list-inline">
                <li class="pull-left">
                    <span class="price"> {{course.price}} </span>
                </li>
                <li>
                    <button v-if="showSoldOut" type="button"
                            v-bind:value="course.id" class="btn cta disable disabled">
                       {{t('Soldout')}}
                       <i class="bg-add-participant pull-right m-xs-top"></i>
                    </button>
                    <button v-if="showWaitingWaitList" @click="$emit('wait-list', course.id)" type="button"
                            :style="corporationStyles"
                            v-bind:class="{'disabled': isEnrollDisabled}"
                            v-bind:value="course.id" class="btn cta waitlist">
                       {{t('Waiting')}}
                       <i class="bg-waitlist pull-right m-xs-top"></i>
                    </button>
                    <button v-if="showWaitList" @click="$emit('wait-list', course.id)" type="button"
                            :style="corporationStyles"
                            v-bind:class="{'disabled': isEnrollDisabled}"
                            v-bind:value="course.id" class="btn cta waitlist">
                       {{t('Waitlist')}}
                       <i class="bg-waitlist pull-right m-xs-top"></i>
                    </button>
                    <button v-if="showEnroll" @click="isEnrollDisabled ? null : $emit('enroll', course.id)" type="button"
                            :style="corporationStyles"
                            v-bind:class="{'disabled': isEnrollDisabled}"
                            v-bind:value="course.id" class="btn cta enroll-card">
                       {{t('Enroll')}}
                       <i class="bg-add-participant pull-right m-xs-top"></i>
                    </button>
                    <button v-if="Loader" v-on:click="null" type="button" class="btn cta disabled enroll-card text-center p-xs-top">
                        <img src="/webroot/images/spinner.gif" class="center-block" height="15" width="15">
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import API from '@/api/index';

export default {
    name: "CourseCard",
    props: {
        course: {
            type: Object
        },
        corporationColor: {
            type: String,
            default() {
                return null;
            }
        }
    },
    computed: {
        corporationStyles() {
            let styles = {};

            if (this.corporationColor) {
                styles.backgroundColor = this.corporationColor;
            }

            return styles;
        },
        isEnrollDisabled() {
            return this.course.id === 827;
        },
        showSoldOut(){
            const c = this.course;
            return !c.user_in_wait_list && c.soldout && (!c.waitlist_mode_enabled && !c.force_wait_list) && !this.showLoader;
        },
        showWaitList(){
            const c = this.course;

            //if(c.force_wait_list && !c.user_in_wait_list){
              //  return true && !this.showLoader;
            //}
            
            if(!c.user_in_wait_list && c.soldout && !c.force_wait_list && (c.waitlist_mode_enabled && c.max_num_waiters <= c.current_users)){
            	return true && !this.showLoader;
            }

            return !c.user_in_wait_list && c.max_num_waiters>c.current_users && c.soldout && (c.waitlist_mode_enabled || !c.force_wait_list) && !this.showLoader;
        },
        showWaitingWaitList(){
            const c = this.course;
            return c.soldout && c.user_in_wait_list && !this.showLoader;
        },
        showEnroll(){
            if(this.course.force_wait_list){
                return false && !this.showLoader
            }

            return !this.course.soldout && !this.showLoader ;
        },
        Loader(){
            return this.showLoader;
        }
    },
    methods: {
        changeReaction(course) {
            this.course.has_like = !this.course.has_like;
            API.main.saveReaction({
                id_course: this.course.id,
                has_like: this.course.has_like
            });
        }
    }
}
</script>

<style scoped>
    .clean {
        text-decoration: none !important;
    }
</style>
